import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SignRoutingModule } from './sign-routing.module';
import { ForgotPasswordComponent } from './components/forgot-password.component';
import { SinginAsComponent } from './components/singin-as.component';
import { SignComponent } from './sign/sign.component';
import { SigninComponent } from './components/signin/signin.component';
import { ResetPasswordComponent } from './components/reset-password.component';
import { PasswordCodeComponent } from './components/password-code.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SignService } from './sign.service';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SignoutComponent } from './components/signout/signout.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SignRoutingModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    SigninComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SinginAsComponent,
    SignComponent,
    PasswordCodeComponent,
    SignoutComponent,
  ],
  providers: [
    SignService
  ]
})
export class SignModule { }
